module.exports = __webpack_public_path__ + "img/simialogopng.8e8a1949.png";